import {useAtomValue} from 'jotai';
import {userAtom} from '@/store/user';
import {getSupplierIdFromEmail} from '@/util/supplier-mapping';
import {normalizedBrandToSupplierIdMapAtom} from '@/store/materials/suppliers';

/**
 * Hook to determine if the current user has access to materials
 *
 * Materials access requires:
 * 1. User email mapped in EMAIL_TO_SUPPLIER_MAP, OR
 * 2. User branding name mapped to supplier ID, AND
 */
export function useMaterialsAccess() {
    const user = useAtomValue(userAtom);
    const brandMap = useAtomValue(normalizedBrandToSupplierIdMapAtom);
    const supplierIdFromEmail = getSupplierIdFromEmail(user?.email ?? '');

    if (!user) return true; // if user hasn't been initialized yet, we assume they have access
    if (supplierIdFromEmail) return true;

    if (user?.branding?.name) {
        const brandName = user.branding.name;
        const brandMapIsPopulated = Object.keys(brandMap).length > 0;

        if (brandMapIsPopulated) {
            const mappedSupplierId = brandMap[brandName];

            if (mappedSupplierId && typeof mappedSupplierId === 'string') {
                return true;
            }
        }
    }

    return false;
}
